import { Avatar, Box, Button, Flex, Select, Text } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FaBars } from "react-icons/fa";
import { useRecoilState } from "recoil";
import { LoggedUser } from "../../atoms/userLogged";
import { BLUEMONEDD, GRAY_NEUTRAL, WHITE } from "../../constants/colors";
import ProfileDrawer from "./components/profileDrawer";
import { useSetRecoilState } from "recoil";
import { selectedClientHeader } from "../../atoms/selectedClientHeader";
import SupervisorClientesApi from "../../services/supervisorClientesApi";
import { clientesSupervisor } from "../../interfaces/defaultInterfaces";
import { useLocation, useParams } from "react-router-dom";
import { JWTToken } from "../../routes/privateRoute";
import moment from "moment";
import jwt_decode from "jwt-decode";
import ModalChangePassword from "./components/modalChangePassword";
import Login from "../../services/loginApi";
import { useCookies } from "react-cookie";
import { useRecoilValue } from "recoil";
import { apiResponseState } from "./../../atoms/loginState";
function Header({ setOpen, open }: any) {
  const apiResponse: any = useRecoilValue(apiResponseState);
  const user = useRecoilState(LoggedUser)[0];
  const [isOpen, setIsOpen] = useState(false);
  const [clientes, setClientes] = useState(Array<clientesSupervisor>);
  const [idClienteDefault, setIdClienteDefault] = useState(0);
  const { idCliente } = useParams();
  const location = useLocation();
  const [lastSegment, setLastSegment] = useState(0);

  const client = useRecoilState(selectedClientHeader)[0];
  const setClient = useSetRecoilState(selectedClientHeader);

  async function getClientes(id: number) {
    try {
      const response = await SupervisorClientesApi.getClientesSupervisor(id);
      setClientes(response);
      setIdClienteDefault(response[0].cliente.id);
      // console.log("idClienteDefault", idClienteDefault)
    } catch (error) {
      console.log(error);
    }
  }

  const [openChangePassword, setOpenChangePassword] = useState(false);

  const refreshToken = localStorage.getItem("refreshToken");
  const token = localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  let jwtRefreshToken: JWTToken = jwt_decode(refreshToken || "");

  function formatRemainingTime(expirationTime: number): string {
    const currentTimeInSeconds = Math.floor(Date.now() / 1000);
    const remainingTimeInSeconds = expirationTime - currentTimeInSeconds;

    const hours = Math.floor(remainingTimeInSeconds / 3600);
    const minutes = Math.floor((remainingTimeInSeconds % 3600) / 60);

    if (hours > 0) {
      return `${hours} horas`;
    } else {
      return `${minutes} minutos`;
    }
  }
  let remainingTime = formatRemainingTime(jwtRefreshToken.exp);

  // eslint-disable-next-line eqeqeq
  const primeiroAcesso = apiResponse?.user?.primeiroAcesso;

  useEffect(() => {
    if (primeiroAcesso) {
      setOpenChangePassword(true);
    } else {
      setOpenChangePassword(false);
    }
  }, []);

  useEffect(() => {
    const pathname = location.pathname;
    const segments = pathname.split("/");
    const lastSegment = segments.pop();

    setLastSegment(isNaN(Number(lastSegment)) ? 0 : Number(lastSegment));

    getClientes(user.id);
  }, [location.pathname]);

  useEffect(() => {
    if (
      location.pathname === "/dashboard" ||
      location.pathname === "/solicitacoes/pagamento/novo" ||
      location.pathname === "/solicitacoes/transferencia/novo" ||
      location.pathname === "/financeiro/cadastro/favoritos" ||
      location.pathname === "/taxas" ||
      location.pathname === "/financeiro/contafixa/cadastro" ||
      location.pathname === "/vendas/boletos/nova" ||
      location.pathname === "/vendas/digitadas/cartao/cadastrar" ||
      location.pathname === "/vendas/digitadas/cadastrar" ||
      location.pathname === "/financeiro/lancamentos" ||
      // location.pathname === "/financeiro/boletos" ||
      location.pathname === "/vendas/boletos" ||
      location.pathname === "/servico" ||
      location.pathname === "/direto" ||
      location.pathname === "/direto/cadastro"
    ) {
      setClient(idClienteDefault);
    }
  }, [location.pathname, clientes]);

  async function GetNewToken() {
    const obj = {
      refreshToken: refreshToken,
    };
    // console.log("chamei a rota de pegar novo token");
    try {
      const response = await Login.refreshToken(obj);
      if (response.status >= 200 && response.status < 300) {
        removeCookie("auth");
        setCookie("auth", true);
      }
      removeCookie("token");
      window.localStorage.removeItem("token");
      setCookie("token", response.data.token);
      window.localStorage.setItem("token", response.data.token);
    } catch (error) {
      console.log("deu erro para pegar um novo token");
      removeCookie("auth");
      console.log("error", error);
    }
  }

  const [cookies, setCookie, removeCookie] = useCookies(); //['color', 'logo1', 'logo2'] ['color', 'logo']

  async function GetNewTokenAfterDesactivatedScreen() {
    const obj = {
      refreshToken: refreshToken,
    };
    try {
      const response = await Login.GetNewTokenAfterDesactivatedScreen(obj);
      removeCookie("token");
      window.localStorage.removeItem("token");
      setCookie("token", response.token);
      window.localStorage.setItem("token", response.token);
    } catch (error) {
      removeCookie("auth");
      console.log("error", error);
    }
  }

  useEffect(() => {
    let interval: NodeJS.Timeout;

    const handleVisibilityChange = () => {
      const isVisible = !document.hidden;
      if (isVisible) {
        clearInterval(interval); // Limpa o intervalo anterior, se existir
        GetNewTokenAfterDesactivatedScreen();
        interval = setInterval(GetNewToken, 10000); // 10 segundos em milissegundos
      } else {
        clearInterval(interval); // Limpa o intervalo se a tela estiver inativa
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Verificar a visibilidade da tela quando o componente é montado
    handleVisibilityChange();

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      clearInterval(interval); // Limpar o intervalo quando o componente desmontar
    };
  }, []);

  const version = process.env.REACT_APP_VERSION ?? "2026.05.06.1";

  return (
    <Flex
      justify={
        !open || user.idLoginTipo === 3 ? "space-between" : "space-between"
      }
      align="center"
      w={"100%"}
      h={"80%"}
      my={2}
    >
      <Flex mx={2}>
        {!open ? (
          <Button mr={2} bg={"none"} onClick={() => setOpen(true)}>
            <FaBars size={"20px"} />
          </Button>
        ) : (
          <></>
        )}
        {user.idLoginTipo === 3 && lastSegment === 0 && (
          <Flex>
            {location.pathname === "/dashboard" ||
              location.pathname === "/solicitacoes/pagamento/novo" ||
              location.pathname === "/solicitacoes/transferencia/novo" ||
              location.pathname === "/financeiro/cadastro/favoritos" ||
              location.pathname === "/taxas" ||
              location.pathname === "/financeiro/contafixa/cadastro" ||
              location.pathname === "/vendas/boletos/nova" ||
              location.pathname === "/vendas/digitadas/cartao/cadastrar" ||
              location.pathname === "/vendas/digitadas/cadastrar" ||
              location.pathname === "/financeiro/lancamentos" ||
              location.pathname === "/vendas/listadevendastemporeal" ||
              // location.pathname === "/financeiro/boletos" ||
              location.pathname === "/vendas/boletos" ||
              location.pathname === "/servico" ||
              location.pathname === "/direto" ||
              location.pathname === "/direto/cadastro" ? (
              <Select
                value={client}
                onChange={(e: any) => setClient(Number(e.target.value))}
              >
                {clientes &&
                  clientes.map((item: any) => {
                    return (
                      <option key={item.cliente.id} value={item.cliente.id}>
                        {item.cliente.isCnpj
                          ? item.cliente.razaoSocial
                          : `${item.cliente.razaoSocial} ${item.cliente.nomeFantasia}`}
                      </option>
                    );
                  })}
              </Select>
            ) : (
              <Select
                value={client}
                placeholder="Todos"
                defaultValue={idClienteDefault}
                onChange={(e: any) => setClient(Number(e.target.value))}
              >
                {clientes &&
                  clientes.map((item: any) => {
                    return (
                      <option key={item.cliente.id} value={item.cliente.id}>
                        {item.cliente.isCnpj
                          ? item.cliente.razaoSocial
                          : `${item.cliente.razaoSocial} ${item.cliente.nomeFantasia}`}
                      </option>
                    );
                  })}
              </Select>
            )}
            {location.pathname !== "/dashboard" &&
              location.pathname !== "/solicitacoes/pagamento/novo" &&
              location.pathname !== "/solicitacoes/transferencia/novo" &&
              location.pathname !== "/financeiro/cadastro/favoritos" &&
              location.pathname !== "/taxas" &&
              location.pathname !== "/financeiro/contafixa/cadastro" &&
              location.pathname !== "/vendas/boletos/nova" &&
              location.pathname !== "/vendas/digitadas/cartao/cadastrar" &&
              location.pathname !== "/vendas/digitadas/cadastrar" &&
              location.pathname !== "/financeiro/lancamentos" &&
              location.pathname !== "/vendas/listadevendastemporeal" &&
              // location.pathname !== "/financeiro/boletos" &&
              location.pathname !== "/vendas/boletos" &&
              location.pathname !== "/servico" &&
              location.pathname !== "/direto" &&
              location.pathname !== "/direto/cadastro" && (
                <Button
                  bgColor={GRAY_NEUTRAL}
                  color={WHITE}
                  fontSize={"0.8rem"}
                  ml={2}
                  onClick={() => {
                    setClient(0);
                  }}
                >
                  Limpar Filtros
                </Button>
              )}
          </Flex>
        )}
      </Flex>
      <Text fontSize={"15"} fontWeight={"medium"} ml={"3%"}>
        {`Vers. ${version} | Sua sessão termina em: ${remainingTime}`}
      </Text>
      <Flex
        justify="center"
        align="center"
        bgColor={BLUEMONEDD}
        w={"16vw"}
        h={"100%"}
        borderLeftRadius={"30px"}
      >
        <Flex direction="column" align="flex-end" justifyContent={"center"}>
          <Text fontSize={"1.5vh"} fontWeight="medium" color={"white"}>
            {user.nome
              .toLowerCase()
              .replace(/(^\w{1})|(\s+\w{1})/g, (letra) => letra.toUpperCase())}
          </Text>
          <Text fontSize={"1.3vh"} color={"white"}>
            {(user.idLoginTipo === 1 && "Gestor") ||
              (user.idLoginTipo === 2 && "Filial") ||
              (user.idLoginTipo === 3 && "Supervisor") ||
              (user.idLoginTipo === 4 && "Cliente") ||
              (user.idLoginTipo === 5 && "Comissionado")}
          </Text>
        </Flex>
        <Box
          onClick={() => {
            // removeCookie('token', { path: '/' });
            setIsOpen(true);
          }}
        >
          <Avatar
            name={user.nome}
            color={BLUEMONEDD}
            ml="3"
            size="sm"
            bg={WHITE}
          />
        </Box>
        <ProfileDrawer isOpen={isOpen} setIsOpen={setIsOpen} />
        <ModalChangePassword
          isOpen={openChangePassword}
          setIsOpen={setOpenChangePassword}
          user={user}
        />
      </Flex>
    </Flex>
  );
}
export default Header;
